var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modal',{attrs:{"name":_vm.name,"classes":"rounded-lg shadow-lg p-5","width":"330","height":"auto"},on:{"closed":function($event){return _vm.$emit('closed')}}},[_c('QRContainer',{attrs:{"text":_vm.text}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }